import { render, staticRenderFns } from "./GetInTouchForm.vue?vue&type=template&id=474af0aa&"
import script from "./GetInTouchForm.vue?vue&type=script&lang=js&"
export * from "./GetInTouchForm.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouchForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports